import apiClient from './client';
import type { SearchParams, SearchResponse } from '../types/search';

/**
 * Search posts using full-text search across title, content, comments, and tags.
 * Optional filters narrow results by sighting type, location radius, or date range.
 */
export const search = async (params: SearchParams): Promise<SearchResponse> => {
  const queryParams: Record<string, string | number> = {
    q: params.query,
    page: params.page ?? 0,
    size: params.size ?? 20,
  };

  if (params.sightingType) {
    queryParams.sightingType = params.sightingType;
  }
  if (params.lat !== undefined) {
    queryParams.lat = params.lat;
  }
  if (params.lon !== undefined) {
    queryParams.lon = params.lon;
  }
  if (params.radiusKm !== undefined) {
    queryParams.radiusKm = params.radiusKm;
  }
  if (params.fromDate) {
    queryParams.fromDate = params.fromDate;
  }
  if (params.toDate) {
    queryParams.toDate = params.toDate;
  }

  const response = await apiClient.get<SearchResponse>('/search', {
    params: queryParams,
  });

  return response.data;
};

export const searchApi = {
  search,
};
